import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useWealth } from '../../../../api';
import { useWealthContext } from '../../../../contexts/wealth-context';
import { useBalanceSheetTableColDefs } from '../../../../hooks/useBalanceSheetTableColDefs';
import type { IModalBalanceEntry } from '../../../../interfaces/balance-sheet-table';
import { BalanceSheetCategoryTitle } from '../BalanceSheetCategoryTitle';
import { BalanceSheetTable } from '../BalanceSheetTable';

interface IProps {
    handleShowModal: (modalEntry: IModalBalanceEntry) => void;
}

export const LiabilityTable: FunctionComponent<IProps> = ({ handleShowModal }) => {
    const { t } = useTranslation();
    const { clientCurrency } = useWealthContext();
    const { liabilities, liabilitiesTotal } = useWealth();

    const liabilitiesColDefs = useBalanceSheetTableColDefs('liabilities', clientCurrency ?? '');

    return (
        <div className="balance-sheet-table__container">
            <BalanceSheetCategoryTitle
                title={t('wealthLiabilitiesSectionTitle')}
                totalText={t('wealthLiabilitiesSectionTotal')}
                currency={clientCurrency}
                totalAmountCurrentYear={liabilitiesTotal}
            />
            <BalanceSheetTable balanceSheetData={liabilities} tableColDefs={liabilitiesColDefs} onRowActionClick={handleShowModal} />
        </div>
    );
};
